import { Box, Button, Flex, Heading } from '@chakra-ui/react'
import type { AppInfoMessage, AppInfoMessagePagedQuery } from 'BrokerTsLib/src/dtos'
import { useGetAllAppInfoMessages } from 'brokertslib/src/hooks/useAppInfoMessage'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Container } from '../../components/Container'
import { Loading } from '../../components/Loading'
import { Pagination } from '../../components/Pagination'
import { Section } from '../../components/Section'
import { WithAuth } from '../../containers/hoc/WithAuth'
import { NewsFilterForm } from '../../containers/news/NewsFilterForm'
import { NewsGrid } from '../../containers/news/NewsGrid'
import { PageContent } from '../../containers/PageContent'
import { PageToolbar } from '../../containers/PageToolbar'
import { useAuth } from '../../context/AuthContext'
import { useApp } from '../../hooks/useApp'
import { Edit } from '../../icons'

const NewsListPageComponent = () => {
  const { product } = useApp()
  const [unreadOnly, setUnreadOnly] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const navigate = useNavigate()

  const { user } = useAuth()!

  const pageSize = 12

  const { mutateAsync: getMessages, data: dataMessages, isLoading: isLoading } = useGetAllAppInfoMessages()
  const [filter, setFilter] = useState<AppInfoMessagePagedQuery>({
    pageSize: pageSize,
    pageIndex: currentPage,
    product: product!,
    shown: true,
    unread: unreadOnly
  })

  useEffect(() => {
    getMessages(filter)
  }, [filter])
  useEffect(() => {
    setCurrentPage(1)
    setFilter({
      ...filter,
      unread: unreadOnly
    })
  }, [unreadOnly])
  useEffect(() => {
    setFilter({
      ...filter,
      pageIndex: currentPage
    })
  }, [currentPage])

  const newsToRender = (dataMessages?.data?.items ?? []) as AppInfoMessage[]

  const totalCount = dataMessages?.data?.totalCount ?? 0

  return (
    <Section>
      <Container>
        <PageContent>
          <PageToolbar
            leftElements={
              <Flex sx={{ gap: 4, alignItems: 'center' }}>
                <Heading as="h1">Aktuality</Heading>
              </Flex>
            }
            rightElements={
              <Flex sx={{ gap: 4 }}>
                {user?.allowEditAppInfoMessages &&
                  <Button colorScheme="primary" onClick={() => navigate('/news/admin')}>
                    <Edit />
                    Správa aktualit
                  </Button>
                }
              </Flex>
            }
          />

          <NewsFilterForm
            unreadOnly={unreadOnly}
            onUnreadOnlyChange={(v: boolean) => setUnreadOnly(v)}
          />

          {!isLoading && <NewsGrid news={newsToRender} />}
          {!isLoading && newsToRender.length <= 0 && <Box>Žádné aktuality nesplňují filtr</Box>}
          {isLoading && <Loading large={true} />}

          <Pagination totalCount={totalCount} currentPage={currentPage} setCurrentPage={setCurrentPage} maxButtonCount={7} pageSize={pageSize} />
        </PageContent>
      </Container>
    </Section>
  )
}


export const NewsListPage = WithAuth(NewsListPageComponent)